import axiosClient from '../../client/axiosClient';
import { API_ENDPOINTS } from '../../endpoints/endpoints';

export const ContentApi = {
  // 콘텐츠 업로드
  uploadContent: async (formData) => {
    try {
    const response = await axiosClient.post(API_ENDPOINTS.CONTENTS, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
    } catch (error) {
      console.error('ContentApi.uploadContent error:', error);
      console.error('Error response:', error.response?.data);
      console.error('Error status:', error.response?.status);
      throw error;
    }
  },

  // 콘텐츠 목록 조회 (excludePopup: true 시 팝업 전용 글은 목록에서 제외)
  getContentList: async (category, page = 0, size = 10, excludePopup = false) => {
    const response = await axiosClient.get(API_ENDPOINTS.CONTENTS, {
      params: { category, page, size, excludePopup: excludePopup ? 'true' : undefined }
    });
    return response.data;
  },

  // 콘텐츠 상세 조회 - category 파라미터 추가
  getContentDetail: async (category, id) => {
    const response = await axiosClient.get(`/contents/${encodeURIComponent(category)}/${id}`);
    return response.data;
  },

  // 콘텐츠 수정 - category는 formData에 포함, 경로는 /{id}만 사용
  updateContent: async (category, id, formData) => {
    // category가 이미 formData에 있는지 확인 후 추가 (중복 방지)
    if (!formData.has('category')) {
    formData.append('category', category);
    }
    
    try {
    const response = await axiosClient.put(`/contents/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
    } catch (error) {
      console.error('ContentApi.updateContent error:', error);
      console.error('Error response:', error.response?.data);
      console.error('Error status:', error.response?.status);
      throw error;
    }
  },

  // 콘텐츠 삭제 - ID만으로 삭제
  deleteContent: async (category, id) => {
    const response = await axiosClient.delete(`/contents/${id}`);
    return response.data;
  },

  // 팝업 콘텐츠 조회
  getPopupContent: async (category) => {
    const response = await axiosClient.get(API_ENDPOINTS.CONTENT_POPUP(category));
    return response.data;
  }
};
